
const PublicRoute = ({ component: Component, ...rest }) => (
  // <Route {...rest} render={props => (
  //   <Component {...props} child={rest.child} />
  // )} />
  <Component child={rest.child} />
)

export default PublicRoute
